import {Dimensions} from 'react-native';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

export class cp { // common call def

  static $cp_hlr_cm10 = (pd={
    mode: 'get/set/itemss/clds',
    b_clr: false, // get, set
    state: '', // items, clds
    cnd: '',
    ld_sortss: [{fld:'_KEY', dtn:'asc/desc'}],
  }) => new Promise( async _o_end1 => {

    let _cnd = ''

    if (bf.f(pd.cnd)) {
      _cnd = pd.cnd;
    }
    else if (bf.f(pd.cm10_key)) {
      _cnd = bf.q('[_KEY]={}'.f(
        pd.cm10_key,
      ));
    }
    else if (bf.f(pd.cm20_key)) {
      _cnd = bf.q(`[cm10b21k]="{}"`.f(
        pd.cm20_key,
      ));
    }

    cf.myCB_hlr({
      elm: 'cm10',
      mode: pd.mode,
      b_clr: pd.b_clr,
      state: pd.state,
      cnd: _cnd,
      ld_sortss: pd.ld_sortss,
      b_withCnd: false,
      do_rfrs: {
      },
      dld_pcksss: {
      },
      od_setDefs: _d_is => {
        return {
        };
      },
      od_insDefs: () => {
        return {
        };
      },
      od_updDefs: () => {
        return {
        };
      },
      od_itemsDefs: _d_is => {
        return {
          pfx: '{}'.f(_d_is.cm10c330),
          b_dlt: (pd.b_wotDlt == true && _d_is.cm10cz10 == '0') ? true : false, // b_wotDlt == true かつ cz10 == '0'
        }
      },
      od_fileDefs: _d_is => {
        return {
        }
      },
    })
    .then( _a_r =>{ // 'ins' の場合に必要
//bf.l('70:{}'.f(global.c?.state[pd.state]))
      _o_end1(_a_r);
    });
  });

  static $cp_load_cm10 = (pd={
    mode: 'slc/items',
    b_clr: false,
    b_wotDlt : false, // without delete
    cm20_key: '',
    cnd: '',
  }) => new Promise( _o_end1 => { //  スタッフ情報 pd: {mode:'items', cm20_key:''}

    let _cnd = '';
    if (bf.f(pd.cnd)) {
      _cnd = pd.cnd;
    }
    else {
      if (bf.f(pd.cm10_key)) {
        _cnd = bf.q('[_KEY]={}'.f(
          pd.cm10_key,
        ));
      }
      else if (bf.f(pd.cm20_key)) {
        _cnd = bf.q(`[cm10b21k]="{}"`.f(
          pd.cm20_key,
        ));
      };
    };


    if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'cm10', 
            n_dms: 2, 
            cnd: _cnd
          })
          .then( _d_cm10s => {
            _o_end2(_d_cm10s);
          });
        };
      })
      .then( _d_cm10s => {
        if (bf.f(_d_cm10s)) {
          cf.myRN_setCmns({
            cm10c310: _d_cm10s.cm10c310,
            cm10c330: _d_cm10s.cm10c330,
          })
          .then(() => {
            global.c?.setState({
              s_cm10b21k: _d_cm10s.cm10b21k,
              s_cm10c120: _d_cm10s.cm10c120 || '',
              s_cm10c310: _d_cm10s.cm10c310,
              s_cm10c320: _d_cm10s.cm10c320,
              s_cm10c330: _d_cm10s.cm10c330,
              s_cm10c410: _d_cm10s.cm10c410 || '10',
              s_cm10cz10: _d_cm10s.cm10cz10 || '10',
              s_cm10i110: _d_cm10s.cm10i110,
            }, ()=>{
              _o_end1(_d_cm10s);
            });
          })
        }
        else {
          cf.myRN_setCmns({
            cm10c310: '',
            cm10c330: '',
          })
          .then(() => {
            global.c?.setState({
              s_cm10b21k: '',
              s_cm10c120: '',
              s_cm10c310: '',
              s_cm10c320: '',
              s_cm10c330: '',
              s_cm10c410: '10',
              s_cm10cz10: '10',
              s_cm10i110: '',
            }, ()=>{
              _o_end1(null);
            });
          })
        };
      });
    }
    else if (pd.mode == 'items') {
      cf.myCB_set_items({
        ctr: 'nlm', 
        elm: 'cm10', 
        n_dms: 3, 
        state: pd.state, 
        cnd: _cnd,
        o_fnc: _d_cm10s => {
          return {
            pfx: '{}'.f(_d_cm10s.cm10c330, _d_cm10s.cm10cz10, ),
            b_dlt: (pd.b_wotDlt == true && _d_cm10s.cm10cz10 == '0') ? true : false, // b_wotDlt == true かつ cz10 == '0'
            stlCta: {
              backgroundColor: (_d_cm10s.cm10c410 == '90') ? ic.g_ccdYP : null,
            },
          }
        },
        ld_sortss: pd.ld_sortss || [{fld:'cm10c330', dtn:'asc'}],
      })
      .then( () => {
        _o_end1();
      });
    };
  });

  static $cp_ins_cm10 = (pd={}) => new Promise( _o_end1 => {
    cf.myRN_user_ins(global.c?.state.s_cm10i110)
    .then((_d_cm10s)=>{
/*
      global.c?.setState({
        sgcd_pageCmns?: bf.p(global.c?.state.sgcd_pageCmns?, _next => {
          _next.cm10_key = _d_cm10s._KEY;
//          _next.cm10c310 = global.c?.state.s_cm10c310;
        }),
      }, ()=>{
        _o_end1(_d_cm10s);
      })
*/
      cf.myRN_setCmns({
        cm10_key: _d_cm10s._KEY,
      })
      .then(() => {
        _o_end1(_d_cm10s);
      });
    });
  });

  static $cp_upd_cm10 = (pd={}) => new Promise( _o_end1 => {
//    cf.myRN_user_upd(global.c?.state.sgcd_pageCmns?.cm10_key, global.c?.state.s_cm10i110)
    cf.myRN_user_upd(global.c?.state.sgcd_pageCmns?.cm10_key, bf.myCM_cnv('lwr', global.c?.state.s_cm10i110))
    .then(()=>{
      //
      let _d_vals = {
        cm10b21k: global.c?.state.sgcd_pageCmns?.cm20_key || '', 
        cm10c120: global.c?.state.s_cm10c120 || '', 
        cm10c310: global.c?.state.s_cm10c310 || '',
        cm10c320: global.c?.state.s_cm10c320 || '',
        cm10c330: global.c?.state.s_cm10c330 || '',
        cm10c410: global.c?.state.s_cm10c410 || '10',
        cm10cz10: global.c?.state.s_cm10cz10 || '10',
//        cm10i110: global.c?.state.s_cm10i110 || '',
        cm10i110: bf.myCM_cnv('lwr', global.c?.state.s_cm10i110) || '',
      };
      let _cnd = bf.q('[_KEY]={}'.f(global.c?.state.sgcd_pageCmns?.cm10_key));
//alert('131:{}, {}'.f(_cnd, _d_vals));
//      cf.myCB_call_iud('upd', 'cm10', _d_vals, _cnd)
      cf.myCB_call_iud({
        ctr: 'upd', 
        elm: 'cm10', 
        d_vals: _d_vals, 
        cnd: _cnd
      })
      .then(()=>{
        if (global.c?.state.sgcd_pageCmns?.cm10_key == global.c?.state.sgc_cm10_key) { // 利用者区分の同期
          cf.myLS_set('cm10c410', global.c?.state.s_cm10c410)
          .then(()=>{
              _o_end1();
          })
        }
        else {
          _o_end1();
        };
      });
    });
  });

  static $cp_load_cm40 = (pd={
    mode: 'set/items',
    b_clr: false,
    state: 'sld_cm40ss', // for items/clds
    cm40_key: '', // for set
    cm40l11e: '', // for items
    cm40l11k: '', // for items
    cm20_key: '', // for items
  }) => new Promise( _o_end1 => {

    let _cnd = '';
    if (bf.f(pd.cm40_key)) {
      _cnd = bf.q(`[_KEY]={}`.f(
        pd.cm40_key || ''
      ));
    }
    else if (bf.f(pd.cm20_key)) {
      _cnd = bf.q(`[cm40b11k]="{}" AND [cm40l11e]="{}" AND [cm40l11k]="{}"`.f(
        pd.cm20_key || '',
        pd.cm40l11e || '',
        pd.cm40l11k || '',
      ));
    };

    if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'cm40', 
            n_dms: 2, 
            cnd: _cnd
          })
          .then( _d_cm40s => {
            _o_end2(_d_cm40s);
          });
        };
      })
      .then( _d_cm40s => {
        if (bf.f(_d_cm40s)) {
          global.c?.setState({
            s_cm40_key: _d_cm40s._KEY,
            s_cm40c310: _d_cm40s.cm40c310,
          }, () => {
            _o_end1(_d_cm40s);
          });
        }
        else {
          global.c?.setState({
            s_cm40_key: '',
            s_cm40c310: '',
          }, () => {
            _o_end1(null);
          });
        };
      });
    }
    else if (pd.mode == 'items') {
      cf.myCB_set_items({
        ctr: 'nlm',
        elm: 'cm40', 
        n_dms: 3,
        state: pd.state, 
        cnd: _cnd,
        o_fnc: _d_cm40s => {
          return {
            pfx: '{}'.f(
              _d_cm40s.cm40c310
            ),
          };
        }
      })
      .then(()=>{
        _o_end1();
      });
    };

  });

  static $cp_ins_cm40 = (pd={
    cm40l11e: '',
    cm40l11k: '',
  }) => new Promise( _o_end1 => {
    let _d_vals = {
      cm40b11k: global.c?.state.sgcd_pageCmns?.cm20_key, // 法人情報
      cm40l11e: pd.cm40l11e || '',
      cm40l11k: pd.cm40l11k || '',
      cm40c110: '',
      cm40c310: global.c?.state.s_cm40c310,
    };
    cf.myCB_call_iud({
      ctr: 'ins', 
      elm: 'cm40', 
      d_vals: _d_vals
    })
    .then( _d_cm40s => {
      _o_end1(_d_cm40s);
    });
  });

  static $cp_upd_cm40 = (pd={
  }) => new Promise( _o_end1 => {
    let _d_vals = {
      cm40c310: global.c?.state.s_cm40c310,
    };
    let _cnd = bf.q(`[_KEY]={}`.f(global.c?.state.sgcd_pageCmns?.cm40_key));
    cf.myCB_call_iud({
      ctr: 'upd', 
      elm: 'cm40', 
      d_vals: _d_vals, 
      cnd: _cnd
    })
    .then( () => {
      _o_end1();
    });
  });

  static $cp_load_cm50 = (pd={
    b_wotDlt: false, // without delete
    cm20_key: '',
    cnd: '',
  }) => new Promise( _o_end1 => { // 商品情報

    let _cnd = '';
    if (bf.f(pd.cnd)) {
      _cnd = pd.cnd;
    }
    else {
      if (pd.cm50_key) {
        _cnd = bf.q('[_KEY]={}'.f(
          pd.cm50_key
        ));
      }
      else if (pd.cm20_key) {
        _cnd = bf.q('[cm50b11k]="{}"'.f( // コースを除く
          pd.cm20_key,
        ));
      };
    };

//bf.l('386:{}'.f(_cnd))
    if (pd.mode == 'get') {
      if (pd.b_clr == true) {
        _o_end1(null);
      }
      else {
//alert('365:{}'.f(pd.do_rfrs))
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'cm50', 
          n_dms: 2, 
          cnd: _cnd,
//          do_rfrs: pd.do_rfrs,
        })
        .then( _d_cm50s => {
          _o_end1(_d_cm50s);
        });
      };
    }
    else if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'cm50', 
            n_dms: 2, 
            cnd: _cnd,
          })
          .then( _d_cm50s => {
            _o_end2(_d_cm50s);
          });
        };
      })
      .then( _d_cm50s => {
        if (bf.f(_d_cm50s)) {
          global.c?.setState({ 
            s_cm50_key: _d_cm50s._KEY,
            s_cm50t110: _d_cm50s.cm50t110 || '0',
            s_cm50t120: _d_cm50s.cm50t120 || '0',
            s_cm50c310: _d_cm50s.cm50c310,
            s_cm50cx10: _d_cm50s.cm50cx10 || '0',
            s_cm50cz10: _d_cm50s.cm50cz10 || '10',
            s_cm50i110: _d_cm50s.cm50i110 || '0',
          }, ()=>{
            _o_end1(_d_cm50s);
          });
        }
        else {
          global.c?.setState({ 
            s_cm50_key: '',
            s_cm50t110: '0',
            s_cm50t120: '0',
            s_cm50c310: '',
            s_cm50cx10: '0',
            s_cm50cz10: '10',
            s_cm50i110: '0',
          }, ()=>{
            _o_end1(null);
          });
        };
      })
    }
    else if (pd.mode == 'items') {
      cf.myCB_set_items({
        ctr: 'nlm',
        elm: 'cm50', 
        n_dms: 3,
        state: pd.state, 
        cnd: _cnd,
        do_rfrs: {
          cm5t: _d_is => bf.q('[_KEY]={}'.f(_d_is.cm50t120 || '0'))
        },
        dld_pcksss: {
          cm50cz10:[
            {key: '0', pfx:'表示しない'},
            {key: '10', pfx:'表示する'},
          ],
        },
        ld_sortss: [
          {fld:'cm50cz10', dtn:'desc', mode:'str'}, 
          {fld:'cm50cx10', dtn:'asc', mode:'nmb'}
        ],
        o_fnc: _d_cm50s => {
          return {
            ctg: '{}'.f( // pckSlc 用の category
              _d_cm50s.cm5tc310,
            ),
            n_ctgOdr: bf.n(_d_cm50s.cm5tcx10 || '0'),
            pfx: '{}'.f(
              _d_cm50s.cm50c310,
            ),
            spf: '{}'.f(
              _d_cm50s.cm50cz10
            ),
            b_dlt: (pd.b_wotDlt == true && _d_cm50s.cm50cz10 == '0') ? true : false, // b_wotDlt == true かつ cz10 == '0'
          };
        }
      })
      .then(()=>{
        _o_end1();
      });
    };
  });

  static $cp_upd_cm50 = (pd={}) => new Promise( _o_end1 => { // 商品情報 の反映
    let _d_vals = {
      cm50t110: global.c?.state.s_cm50t110 || '0',
      cm50t120: global.c?.state.s_cm50t120 || '0',
      cm50c310: global.c?.state.s_cm50c310,
      cm50cx10: global.c?.state.s_cm50cx10 || '0',
      cm50cz10: global.c?.state.s_cm50cz10 || '10',
      cm50i110: global.c?.state.s_cm50i110 || '0',
      cm50i120: global.c?.state.s_cm50i120 || '0',
      cm50i130: global.c?.state.s_cm50i130 || '0',
      cm50i140: global.c?.state.s_cm50i140 || '0',
      cm50i150: global.c?.state.s_cm50i150 || '0',
    };
    let _cnd = bf.q('[_KEY]={}'.f(global.c?.state.sgcd_pageCmns?.cm50_key));
    cf.myCB_call_iud({
      ctr: 'upd', 
      elm: 'cm50', 
      d_vals: _d_vals, 
      cnd: _cnd
    })
    .then(()=>{
      _o_end1();
    });
  });

  static $cp_hlr_cm5t = (pd={
    mode: 'get/set/itemss/clds',
    b_clr: false, // get, set
    state: '', // items, clds
    cnd: '',
    ld_sortss: [{fld:'_KEY', dtn:'asc/desc'}],
  }) => new Promise( async _o_end1 => {
//bf.l('521:{}'.f(pd.cnd));
    cf.myCB_hlr({
      elm: 'cm5t',
      mode: pd.mode,
      b_clr: pd.b_clr,
      state: pd.state,
      cnd: pd.cnd || '',
      do_rfrs: {
      },
      dld_pcksss: {
        cm5tcz10:[
          {key: '0', pfx:'表示しない'},
          {key: '10', pfx:'表示する'},
        ],
      },
      ld_sortss: pd.ld_sortss || [
        {fld:'cm5tcz10', dtn:'desc', mode:'str'}, 
        {fld:'cm5tcx10', dtn:'asc', mode:'nmb'}
      ],
      b_withCnd: false,
      od_setDefs: _d_is => {
//bf.l('535:{}'.f(_d_is));
        if (bf.f(_d_is)) {
          cf.myRN_setCmns({
            cm5t_key: _d_is._KEY,
          });
          return {
            s_cm5tc310: _d_is.cm5tc310 || '',
            s_cm5tcx10: _d_is.cm5tcx10 || '0',
            s_cm5tcz10: _d_is.cm5tcz10 || '10',
          };
        }
        else {
          return {
            s_cm5tc310: '',
            s_cm5tcx10: '0',
            s_cm5tcz10: '10',
          };
        };
      },
      od_insDefs: () => {
        let _d = {
          cm5tb11k: global.c?.state.sgcd_pageCmns?.cm20_key,
          cm5tc110: '',
        };
//bf.l('562:{}'.f(_d))
        return _d;
      },
      od_updDefs: () => {
        return {
          cm5tc310: global.c?.state.s_cm5tc310,
          cm5tcx10: global.c?.state.s_cm5tcx10,
          cm5tcz10: global.c?.state.s_cm5tcz10,
        };
      },
      od_upsDefs: () => {
        return {
          cm5tc310: global.c?.state.s_cm5tc310,
          cm5tcx10: global.c?.state.s_cm5tcx10,
          cm5tcz10: global.c?.state.s_cm5tcz10,
        };
      },
      od_itemsDefs: _d_is => {
        return {
          pfx: '{}'.f(
            _d_is.cm5tc310
          ),
          spf: '{}'.f(
            _d_is.cm5tcz10,
          ),
          b_dlt: (pd.b_wotDlt == true && _d_is.cm5tcz10 == '0') ? true : false, // b_wotDlt == true かつ cz10 == '0'
        }
      },
      od_fileDefs: _d_is => {
        return {
        }
      },
    })
    .then( _a_r =>{ // 'ins' の場合に必要
      _o_end1(_a_r);
    });
  });

  static cld_onChgss = () => [
  ];

}
